import SelectProductVariantManager from "./SelectProductVariantManager";

export default SelectProductVariantManager;
